import {HttpClient} from "@angular/common/http";
import {Inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SiteProviderModel} from "../models/site-provider.model";
import {SiteProviderRequestModel} from "../models/site-provider-request.model";

@Injectable({providedIn: 'root'})
export class SiteProvidersService {

  private readonly baseUrl = '/settings/schedulingProjectDataSource';

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  // Archived records are asked for on purpose, by both callers: the Providers table shows them
  // with their Active switch off rather than hiding them, and a Scheduling Project Template has to
  // keep showing an archived source it already points at so the user can see and replace it.
  getAll(): Observable<SiteProviderModel[]> {
    return this.http.get<SiteProviderModel[]>(this.baseUrl, {params: {includeArchived: true}});
  }

  create(payload: SiteProviderRequestModel): Observable<SiteProviderModel> {
    return this.http.put<SiteProviderModel>(this.baseUrl, payload);
  }

  update(id: string, payload: SiteProviderRequestModel): Observable<SiteProviderModel> {
    return this.http.post<SiteProviderModel>(`${this.baseUrl}/${id}`, payload);
  }

  // Archives, does not delete - the record keeps existing with archive: true.
  archive(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

}
